import emarticonAxios from '@/plugins/emarticonAxios';
import store from '@/store';

// 1.1 공통 코드 조회
const GET_COMMON_CODES = `/api/v1.0.0/sys/cmmn-codes`;

// 1.2 공통코드 상세조회
const GET_COMMON_CODE = '/api/v1.0.0/sys/cs-codes';

// 2.1 토큰발행(POS 로그인)
const POST_POS_LOGIN = '/api/prepaid-card/v1.0.0/pos/login';

// 3.1 선불카드 조회
const GET_PREPAID_ACTIVATION = '/api/prepaid-card/v1.0.0/activation';

// 3.2 선불카드 사용
const POST_PREPAID_REDEEM_CASH = '/api/prepaid-card/v1.0.0/redeem-cash';

// 3.3 선불카드 사용 취소
const PUT_PREPAID_REDEEM_VOID_CASH = '/api/prepaid-card/v1.0.0/redeem-void-cash';

// 3.4 선불카드 사용 망취소
const DELETE_PREPAID_REDEEM_REVERSAL_CASH = '/api/prepaid-card/v1.0.0/redeem-reversal-cash';

// 3.5 선불카드 사용 대사
const POST_PREPAID_RECONCILIATION = '/api/prepaid-card/v1.0.0/reconciliation';

// 3.6 카드 보관함 조회
const GET_PREPAID_CARDBOX = '/api/v1.0.0/prepaid-card/prepaid-card-box';
const GET_PREPAID_CARDBOX_ENC = '/api/v1.0.0/emarticon/prepaid-card-box';

// 3.6.1 카드 보관함 조회 리스트
const GET_PREPAID_CARDBOX_LIST = '/api/v1.0.0/prepaid-card/prepaid-card-box-list';
const GET_PREPAID_CARDBOX_LIST_ENC = '/api/v1.0.0/emarticon/prepaid-card-box-list';

// 3.7 선불카드 활성화
const PUT_PREPAID_ACTIVATION = '/api/v1.0.0/prepaid-card/activation';

// 선불카드 상태값 변경(이용중지/이용중지 취소)
const UPDATE_PREPAID_CARD_STATUS ="/api/v1.0.0/prepaid-card/{{prepaidCardNo}}";
const UPDATE_PREPAID_CARD_STATUS_ENC ="/api/v1.0.0/emarticon/{{prepaidCardNo}}";

// 선불카드 조회(단건)
const GET_PREPAID_CARD ='/api/v1.0.0/prepaid-card/{{ctmmnyNo}}/{{prepaidCardNo}}';
const GET_PREPAID_CARD_ENC ='/api/v1.0.0/emarticon/{{ctmmnyNo}}/{{prepaidCardNo}}';

// 선불카드 조회
const GET_PREPAID_CARDS = '/api/prepaid-card/v1.0.0/prepaid-cards';

// 선불카드 사용 내역
// const GET_PREPAID_REDEEM_DETAILS = '/api/v1.0.0/prepaid-card/redeem-details';
const GET_PREPAID_REDEEM_DETAILS = '/api/v1.0.0/emarticon/prepaid-card/redeem-details';
const GET_PREPAID_REDEEM_DETAILS_ENC = '/api/v1.0.0/emarticon/redeem-details';

// 선불카드 사용 내역(단건)
const GET_PREPAID_REDEEM_DETAIL = '/api/v1.0.0/prepaid-card/redeem-detail-nonmember';

// 선불카드 충전 내역
// const GET_PREPAID_RELOAD_DETAILS = '/api/v1.0.0/prepaid-card/reload-details';
const GET_PREPAID_RELOAD_DETAILS = '/api/v1.0.0/emarticon/prepaid-card/reload-details';
const GET_PREPAID_RELOAD_DETAILS_ENC = '/api/v1.0.0/emarticon/reload-details';

// 선불카드 충전 내역 리스트
// const GET_PREPAID_RELOAD_DETAIL_LIST = '/api/v1.0.0/prepaid-card/{{prepaidCardNo}}/reload-detail-list';
const GET_PREPAID_RELOAD_DETAIL_LIST = '/api/v1.0.0/emarticon/prepaid-card/{{prepaidCardNo}}/reload-detail-list';
const GET_PREPAID_RELOAD_DETAIL_LIST_ENC = '/api/v1.0.0/emarticon/{{prepaidCardNo}}/reload-detail-list';

// 선불카드 충전 취소
const PUT_RELOAD_CANCEL_CASH = '/api/v1.0.0/prepaid-card/payment';
const PUT_RELOAD_CANCEL_CASH_ENC = '/api/v1.0.0/emarticon/payment';

// 선불카드 선물 내역
const GET_PREPAID_GIFT_DETAILS = '/api/v1.0.0/prepaid-card/gift-details';
const GET_PREPAID_GIFT_DETAILSH_ENC = '/api/v1.0.0/emarticon/gift-details';

// 은행정보 가져오기
const GET_BANK_INFO = '/api/v1.0.0/prepaid-card/refund/bankInfo';

// 환불 요청
const POST_REQUEST_REFUND = "/api/v1.0.0/prepaid-card/refund";
const POST_REQUEST_REFUND_ENC = "/api/v1.0.0/emarticon/refund";

// 환불요청 (선불카드  상태값 변경)
const PUT_REQUEST_REFUND = "/api/prepaid-card/v1.0.0/refund/{{prepaidCardNo}}";

// 구매취소
const PUT_PREPAID_PAYMENT_VOID = '/api/v1.0.0/prepaid-card/payment';
const PUT_PREPAID_PAYMENT_VOID_ENC = '/api/v1.0.0/emarticon/payment';

// 대표카드 변경
const PUT_REPRESENTATIVE_CARD = '/api/v1.0.0/prepaid-card/{{prepaidCardNo}}/representative';
const PUT_REPRESENTATIVE_CARD_ENC = '/api/v1.0.0/emarticon/{{prepaidCardNo}}/representative';

// 선불카드 숨김처리
const PUT_PREPAID_CARD_HIDE = '/api/v1.0.0/prepaid-card/{{prepaidCardNo}}/display/hide';
const PUT_PREPAID_CARD_HIDE_ENC = '/api/v1.0.0/emarticon/{{prepaidCardNo}}/display/hide';

// const PUT_PREPAID_CARD_HIDE = '/api/v1.0.0/prepaid-card/{{prepaidCardNo}}/hide';
// const PUT_PREPAID_CARD_HIDE_ENC = '/api/v1.0.0/emarticon/{{prepaidCardNo}}/hide';

// 선불카드 상품 페이징 조회
const GET_PREPAID_CARD_GOODS = '/api/v1.0.0/prepaid-card/goods';

// 선불카드 B2B 상품 페이징 조회
const GET_PREPAID_CARD_B2B_GOODS_LIST = '/api/v1.0.0/prepaid-card/b2b/goods-list';

// 선불카드 상품 및 혜택 정보 조회(단건)
const GET_PREPAID_CARD_GOODS_BENEFIT = '/api/v1.0.0/prepaid-card/goods-benefit-info';

// 2023년 이전 이마티콘 조회
const GET_SSG_PAY_EMARTICON = '/api/v1.0.0/prepaid-card/emarticon/ssgpay'

// 계좌 유효성 검증
const GET_ACCOUNT_VERIFICATION = "/api/v1.0.0/prepaid-card/account-verification";

// 자동충전 설정 조회
const GET_AUTO_RELOAD = '/api/v1.0.0/prepaid-card/auto-reload/{{prepaidCardNo}}'
const GET_AUTO_RELOAD_ENC = '/api/v1.0.0/emarticon/auto-reload/{{prepaidCardNo}}'

// 자동 충전 설정 저장
const POST_AUTO_RELOAD = '/api/v1.0.0/prepaid-card/auto-reload'
const POST_AUTO_RELOAD_ENC = '/api/v1.0.0/emarticon/auto-reload'

// 자동충전 설정 수정/해지
const PUT_AUTO_RELOAD = '/api/v1.0.0/prepaid-card/auto-reload/{{prepaidCardNo}}'
const PUT_AUTO_RELOAD_ENC = '/api/v1.0.0/emarticon/auto-reload/{{prepaidCardNo}}'

// 결제빌키목록 조회
const PUT_PAYMENT_METHODS = '/api/v1.0.0/prepaid-card/payment-methods'
const PUT_PAYMENT_METHODS_ENC = '/api/v1.0.0/emarticon/payment-methods'

// 자동충전 퀵계좌이체 빌링키 발급
const POST_QUICK_ACCOUNT_TRANSFER = '/api/v1.0.0/prepaid-card/account-transfer/billingkey-issued'

// 선불카드 이미지 목록 조회
const GET_PREPAID_CARD_IMAGE_LIST = '/api/v1.0.0/prepaid-card/image-list';

// 선불카드 이미지 카테고리 목록  조회
const GET_PREPAID_CARD_IMAGE_CATEGORY = '/api/v1.0.0/prepaid-card/image-category';

// 선불카드 환불 신청전 선불카드 정보 조회
const GET_PREPAID_REFUNDINFO = '/api/v1.0.0/prepaid-card/refundInfo/{{prepaidCardNo}}';
const GET_PREPAID_REFUNDINFO_ENC = '/api/v1.0.0/emarticon/refundInfo/{{prepaidCardNo}}';

// 선불카드 충전 혜택 조회
const GET_PREPAID_CARD_RELOAD_BENEFITS = '/api/v1.0.0/prepaid/prepaidcard-reload-bnefs';

// 선불카드 자동충전 혜택 조회
const GET_PREPAID_CARD_AUTORELOAD_BENEFITS = '/api/v1.0.0/prepaid/prepaidcard-autoreload-bnefs';

// 선불카드 시상용 토큰 발급
const GET_AWARD_CODE = '/api/emarticon/v1.0.0/another-token';

// 본인인증 휴대폰
const GET_PHONE_CERT = '/api/v1.0.0/webapp/commonCert/phone';

// 이마티콘 관리자 비밀번호 정책 조회
const GET_ADMIN_MBER_PWD_POLICY = '/api/v1.0.0/emarticon/password-policy/{{ctmmnyNo}}';

// 이마티콘 회원 비밀번호 저장
const POST_MBER_PASSWORD = '/api/v1.0.0/emarticon/mber-password';

// 이마티콘 회원 비밀번호 설정 여부 조회
const POST_CHECK_PASSWORD_EXIST = '/api/v1.0.0/emarticon/check-password-exist';

// 이마티콘 회원 비밀번호 검증
const POST_CHECK_MBER_PASSWORD = '/api/v1.0.0/emarticon/check-mber-password';

// 회원 검증
const GET_CHECK_MBER_INFO = '/api/v1.0.0/emarticon/check-mber';

// 선불카드 개요 조회
const GET_PREPAID_CARD_OVERVIEW = '/api/v1.0.0/prepaid-card/overview';

// 선불카드 번호 복호화
const GET_PREPAID_CARD_DECRYPT = '/api/v1.0.0/emarticon/decrypt/{{prepaidCardNo}}';

// 회원 확인
const GET_MEMBER_IDENTIFY = '/api/v1.0.0/emarticon/member-identify';

// method
const POST = "POST";
const GET = "GET";
const PUT = "PUT";
const DEL = "DELETE";

const requsetApi = async (method, path, params, config) => {
  let result = {};
  switch (method) {
    case GET:
      result = await emarticonAxios.get(path, config);
      break;
    case POST:
      result = await emarticonAxios.post(path, params, config);
      break;
    case DEL:
      result = await emarticonAxios.delete(path, params);
      break;
    case PUT:
      result = await emarticonAxios.put(path, params, config);
      break;

  }
  // TODO 성공이지만 에러코드로 올 경우 체크해야할 부분 추가
  return result;
};

const makeRequest = async (method, path, params) => {
  let headers = {};

  const config = {
    method,
    headers
  };


  // get param 처리
  if (method == GET && params) {
    config.params = {...params}
  }

  // del param
  else if (method == DEL) {
    params = {data:{...params}}
  }

  return requsetApi(method, path, params, config);
};

const callApi = async (method, path, params) => {
  const data = await makeRequest(method, path, params);
  return data;
};

// path params 처리
const getUrl = (url, params)=>{
  // 초기화
  const newParams  = {...params}

  if (newParams.prepaidCardNo) {
    const regex = /{{prepaidCardNo}}/i;
    url = url.replace(regex, newParams.prepaidCardNo)
  }
  if (newParams.ctmmnyNo) {
    const regex = /{{ctmmnyNo}}/i;
    url = url.replace(regex, newParams.ctmmnyNo)
  }
  if (newParams.mberNo) {
    const regex = /{{mberNo}}/i;
    url = url.replace(regex, newParams.mberNo)
  }

  return url;
}

export default {
  //2.1 공통 코드 조회
  getCommonCodes : (params) => callApi(POST, GET_COMMON_CODES, params),

  // 2.1 토큰발행(POS 로그인)
  postPosLogin : (params) => callApi(POST, POST_POS_LOGIN, params),

  // 3.1 선불카드 조회
  getPrepaidActivation : (params) => callApi(GET, GET_PREPAID_ACTIVATION, params),

  // 3.2 선불카드 사용
  postPrepiadRedeemCash : (params) => callApi(POST, POST_PREPAID_REDEEM_CASH, params),

  // 3.3 선불카드 사용 취소
  putPrepaidRedeemVoidCash : (params) => callApi(PUT, PUT_PREPAID_REDEEM_VOID_CASH, params),

  // 3.4 선불카드 사용 망취소
  deletePrepaidRedeemReversalCash : (params) => callApi(PUT, DELETE_PREPAID_REDEEM_REVERSAL_CASH, params),

  // 3.5 선불카드 사용 대사
  postPrepaidReconciliation : (params) => callApi(PUT, POST_PREPAID_RECONCILIATION, params),

  // 3.6 카드 보관함 조회
  getPrePaidCardBox : (params) => callApi(GET, store.state.isMberPwdAuthenticated ? GET_PREPAID_CARDBOX : GET_PREPAID_CARDBOX_ENC, params),

  // 3.6.1 카드 보관함 조회 리스트
  getPrePaidCardBoxList : (params) => callApi(GET, store.state.isMberPwdAuthenticated ? GET_PREPAID_CARDBOX_LIST : GET_PREPAID_CARDBOX_LIST_ENC, params),

  // 3.7 선불카드 활성화
  putPrepaidActivation : (params) => callApi(PUT, PUT_PREPAID_ACTIVATION, params),

  // 선불카드 상태값 변경(이용중지/이용중지 취소)
  updatePrepaidCardStatus: (params, pathVal) => callApi(PUT, getUrl(store.state.isMberPwdAuthenticated ? UPDATE_PREPAID_CARD_STATUS: UPDATE_PREPAID_CARD_STATUS_ENC, pathVal), params),

  // 선불카드 조회(단건)
  getPrepaidCard : (params, pathVal) => callApi(GET, getUrl(store.state.isMberPwdAuthenticated ? GET_PREPAID_CARD : GET_PREPAID_CARD_ENC, pathVal), params),

  // 선불카드 조회
  getPrepaidCards : (params) => callApi(GET, GET_PREPAID_CARDS, params),

  // 선불카드 사용 내역
  getPrepaidRedeemDetail : (params) => callApi(GET, store.state.isMberPwdAuthenticated ? GET_PREPAID_REDEEM_DETAILS : GET_PREPAID_REDEEM_DETAILS_ENC, params),

  // 선불카드 사용 내역(단건)
  getPrepaidRedeemDetailNon : (params) => callApi(GET, GET_PREPAID_REDEEM_DETAIL, params),

  // 선불카드 충전 내역
  getPrepaidReloadDetail : (params) => callApi(GET, store.state.isMberPwdAuthenticated ? GET_PREPAID_RELOAD_DETAILS : GET_PREPAID_RELOAD_DETAILS_ENC, params),

  // 선불카드 충전 내역 리스트 조회
  getPrepaidReloadDetailList : (pathVal) => callApi(GET, getUrl(store.state.isMberPwdAuthenticated ? GET_PREPAID_RELOAD_DETAIL_LIST : GET_PREPAID_RELOAD_DETAIL_LIST_ENC, pathVal)),

  // 선불카드 충전 취소
  putReloadCancelCash : (params) => callApi(PUT, store.state.isMberPwdAuthenticated ? PUT_RELOAD_CANCEL_CASH : PUT_RELOAD_CANCEL_CASH_ENC, params),

  // 선불카드 선물 내역
  // getPrepaidGiftDetail : (params) => callApi(GET, store.state.isMberPwdAuthenticated ? GET_PREPAID_GIFT_DETAILS : GET_PREPAID_GIFT_DETAILSH_ENC, params),
  // 선불카드 선물내역 - 정보보안 조치로 비밀번호 해지 후에도 암호화 값으로 처리
  getPrepaidGiftDetail : (params) => callApi(GET, GET_PREPAID_GIFT_DETAILSH_ENC, params),

  // 은행정보 조회
  getBankInfo: () => callApi(GET, GET_BANK_INFO),

  // 환불 요청
  postRequestRefund: (params) => callApi(POST, getUrl(store.state.isMberPwdAuthenticated ? POST_REQUEST_REFUND : POST_REQUEST_REFUND_ENC), params),

  // 환불요청 (선불카드 상태값 변경)
  putRequestRefund: (params, pathVal) => callApi(PUT, getUrl(PUT_REQUEST_REFUND, pathVal), params),

  // 대표카드 변경
  putRepresentativeCard : (pathVal) => callApi(PUT, getUrl(store.state.isMberPwdAuthenticated ? PUT_REPRESENTATIVE_CARD : PUT_REPRESENTATIVE_CARD_ENC, pathVal)),

  // 구매취소
  putPrepaidPaymentVoid: (params) => callApi(PUT, store.state.isMberPwdAuthenticated ? PUT_PREPAID_PAYMENT_VOID : PUT_PREPAID_PAYMENT_VOID_ENC, params),

  // 구매취소 - 선물 별도 분리 > 정보보안 조치로 비밀번호 해지 후에도 암호화 값으로 처리
  putGiftPrepaidPaymentVoid: (params) => callApi(PUT, PUT_PREPAID_PAYMENT_VOID_ENC, params),

  // 선불카드 숨김처리
  putPrepaidCardHide : (pathVal, params) => callApi(PUT, getUrl(store.state.isMberPwdAuthenticated ? PUT_PREPAID_CARD_HIDE: PUT_PREPAID_CARD_HIDE_ENC, pathVal), params),

  // 선불카드 상품 페이징 조회
  getPrepaidCardGoods : (params) => callApi(GET, GET_PREPAID_CARD_GOODS, params),

  // 선불카드 상품 페이징 조회
  getPrepaidCardB2BGoodsList : (params) => callApi(GET, GET_PREPAID_CARD_B2B_GOODS_LIST, params),

  // 선불카드 상품 및 혜택 정보 조회(단건)
  getPrepaidCardGoodsInfoAndBenefit : (params) => callApi(GET, GET_PREPAID_CARD_GOODS_BENEFIT, params),

  // 2023년 이전 이마티콘 조회
  getSsgPayEmarticon: () => callApi(GET, GET_SSG_PAY_EMARTICON),

  // 계좌 유효성 검증
  getAccountVerification: (param) => callApi(GET, GET_ACCOUNT_VERIFICATION, param),

  // 자동충전 설정 조회
  getAutoReload: (pathVal) => callApi(GET, getUrl(store.state.isMberPwdAuthenticated ? GET_AUTO_RELOAD: GET_AUTO_RELOAD_ENC, pathVal)),

  // 자동 충전 설정 저장
  postAutoReload: (params) => callApi(POST, store.state.isMberPwdAuthenticated ? POST_AUTO_RELOAD : POST_AUTO_RELOAD_ENC, params),

  // 자동충전 설정 수정/해지
  putAutoReload: (params, pathVal) => callApi(PUT, getUrl(store.state.isMberPwdAuthenticated ? PUT_AUTO_RELOAD : PUT_AUTO_RELOAD_ENC, pathVal), params),

  // 결제빌키목록 조회
  putPaymentMerhods: (params) => callApi(PUT,store.state.isMberPwdAuthenticated ?  PUT_PAYMENT_METHODS : PUT_PAYMENT_METHODS_ENC, params),

  // 자동충전 퀵계좌이체 빌링키 발급
  postQuickAccountTransfer: (params) => callApi(POST,POST_QUICK_ACCOUNT_TRANSFER, params),

  // 선불카드 이미지 목록 조회
  getPrepaidCardImageList : () => callApi(GET, GET_PREPAID_CARD_IMAGE_LIST),

  // 선불카드 이미지 카테고리 목록 조회
  getPrepaidCardImageCategory : () => callApi(GET, GET_PREPAID_CARD_IMAGE_CATEGORY),

  // 선불카드 환불 신청전 선불카드 정보 조회
  getRefundInfo: (params, pathVal) => callApi(GET, getUrl(store.state.isMberPwdAuthenticated ? GET_PREPAID_REFUNDINFO : GET_PREPAID_REFUNDINFO_ENC, pathVal), params),

  // 선불카드 충전 혜택 정보 조회
  getReloadBenefits: () => callApi(GET, GET_PREPAID_CARD_RELOAD_BENEFITS),

  // 선불카드 자동 충전 혜택 정보 조회
  getAutoReloadBenefits: () => callApi(GET, GET_PREPAID_CARD_AUTORELOAD_BENEFITS),

  // 선불카드 자동 충전 혜택 정보 조회
  getAwardCode: (param) => callApi(GET, GET_AWARD_CODE, param),

  // 공통코드 상세조회
  getCommonCode: (param) => callApi(GET, GET_COMMON_CODE, param),

  // 본인인증
  certResult: (certPath, params) => callApi(GET, certPath, params),

  // 휴대폰 본인인증
  getPhoneCert: (params) => callApi(GET, GET_PHONE_CERT, params),

  // 이마티콘 관리자 비밀번호 정책 조회
  getAdminMberPwdPolicy: (pathVal) => callApi(GET, getUrl(GET_ADMIN_MBER_PWD_POLICY, pathVal)),

  // 이마티콘 회원 비밀번호 설정 여부 조회
  postCheckPasswordExist: () => callApi(POST, POST_CHECK_PASSWORD_EXIST),

  // 이마티콘 회원 비밀번호 검증
  postCheckMberPassword: (params) => callApi(POST, POST_CHECK_MBER_PASSWORD, params),

  // 이마티콘 회원 비밀번호 저장
  postMberPassword: (params) => callApi(POST, POST_MBER_PASSWORD, params),

  // 회원 검증
  checkMberInfo: (param) => callApi(POST, GET_CHECK_MBER_INFO, param),

  // 선불카드 개요 조회
  getPrepaidCardOverview: (param) => callApi(GET, GET_PREPAID_CARD_OVERVIEW, param),

  // 선불카드 번호 복호화
  getPrepaidCardDecrypt: (pathVal) => callApi(GET, getUrl(GET_PREPAID_CARD_DECRYPT, pathVal)),

  // 회원 확인
  getMemberIdentify: (param) => callApi(GET, GET_MEMBER_IDENTIFY, param),

};
